export const SEARCH_RAFFLES_SHORTCUT = 'shift+r';
export const SEARCH_ANIMALS_SHORTCUT = 'shift+a';

export const BET_TO_TICKET_SHORTCUT = 'shift+b';

export const PRINT_TICKET_SHORTCUT = 'shift+p';
